module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table3"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year1) + "年")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year2) + "年")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "8"
    }
  }, [_vm._v("连续型电子出版物"), _c('br'), _vm._v("年度销售收入（万元）")]), _vm._v(" "), _c('td', [_vm._v("连续型电子出版物"), _c('br'), _vm._v("国内发行和销售收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales1",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales1", $$v)
      },
      expression: "params.firstSales1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales1",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales1", $$v)
      },
      expression: "params.secondSales1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("海外发行收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales2", $$v)
      },
      expression: "params.firstSales2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales2", $$v)
      },
      expression: "params.secondSales2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("出让版权的收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales3", $$v)
      },
      expression: "params.firstSales3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales3", $$v)
      },
      expression: "params.secondSales3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("与出版相关活动收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales4", $$v)
      },
      expression: "params.firstSales4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales4", $$v)
      },
      expression: "params.secondSales4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("连续型电子出版物"), _c('br'), _vm._v("及新媒体网站上"), _c('br'), _vm._v("所做广告收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales5", $$v)
      },
      expression: "params.firstSales5"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales5", $$v)
      },
      expression: "params.secondSales5"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("提供内容审校加工等"), _c('br'), _vm._v("各种服务的收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales6),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales6", $$v)
      },
      expression: "params.firstSales6"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales6),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales6", $$v)
      },
      expression: "params.secondSales6"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales7",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales7),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales7", $$v)
      },
      expression: "params.firstSales7"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales7",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales7),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales7", $$v)
      },
      expression: "params.secondSales7"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales", $$v)
      },
      expression: "params.firstSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales", $$v)
      },
      expression: "params.secondSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "7"
    }
  }, [_vm._v("连续型电子出版物年度支出（万元）")]), _vm._v(" "), _c('td', [_vm._v("出版团队的人员"), _c('br'), _vm._v("成本费用"), _c('br'), _vm._v("（包括工资、福利、奖金等）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay1", $$v)
      },
      expression: "params.firstPay1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay1", $$v)
      },
      expression: "params.secondPay1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("房租水电等"), _c('br'), _vm._v("运营成本费用")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay2", $$v)
      },
      expression: "params.firstPay2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay2", $$v)
      },
      expression: "params.secondPay2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("获取内容及"), _c('br'), _vm._v("审校加工等"), _c('br'), _vm._v("各种劳务的支出")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay3", $$v)
      },
      expression: "params.firstPay3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay3", $$v)
      },
      expression: "params.secondPay3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("印刷压盘包装等费用")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay4", $$v)
      },
      expression: "params.firstPay4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay4", $$v)
      },
      expression: "params.secondPay4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("新媒体上的投入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay5", $$v)
      },
      expression: "params.firstPay5"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay5", $$v)
      },
      expression: "params.secondPay5"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他支出")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay6", $$v)
      },
      expression: "params.firstPay6"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay6", $$v)
      },
      expression: "params.secondPay6"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay", $$v)
      },
      expression: "params.firstPay"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay", $$v)
      },
      expression: "params.secondPay"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n            连续型电子出版物年税费（万元）"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("指与连续型电子出版相关的企业所得缴纳税费，含营业税和所得税。")])]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstTax",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTax", $$v)
      },
      expression: "params.firstTax"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondTax",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTax", $$v)
      },
      expression: "params.secondTax"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("连续型电子出版物"), _c('br'), _vm._v("年度利润（税后）总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstProfit", $$v)
      },
      expression: "params.firstProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondProfit", $$v)
      },
      expression: "params.secondProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("获得基金类资助（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstFund",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstFund", $$v)
      },
      expression: "params.firstFund"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondFund",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondFund", $$v)
      },
      expression: "params.secondFund"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("主办主管单位给与的经费支持（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSuperior",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSuperior", $$v)
      },
      expression: "params.firstSuperior"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSuperior",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSuperior", $$v)
      },
      expression: "params.secondSuperior"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("载体出版"), _c('br'), _vm._v("经营情况")]), _vm._v(" "), _c('td', [_vm._v("销售数量（套/张）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSalesVolumes",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSalesVolumes", $$v)
      },
      expression: "params.firstSalesVolumes"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSalesVolumes",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSalesVolumes", $$v)
      },
      expression: "params.secondSalesVolumes"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbSales", $$v)
      },
      expression: "params.firstZtcbSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbSales", $$v)
      },
      expression: "params.secondZtcbSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbProfit", $$v)
      },
      expression: "params.firstZtcbProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbProfit", $$v)
      },
      expression: "params.secondZtcbProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("\n            载体出版发行的渠道及占比\n            "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("新华书店%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne", $$v)
      },
      expression: "params.firstZtcbDistributionChanne"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne", $$v)
      },
      expression: "params.secondZtcbDistributionChanne"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("馆配商%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne1", $$v)
      },
      expression: "params.firstZtcbDistributionChanne1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne1", $$v)
      },
      expression: "params.secondZtcbDistributionChanne1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("邮局%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne2", $$v)
      },
      expression: "params.firstZtcbDistributionChanne2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne2", $$v)
      },
      expression: "params.secondZtcbDistributionChanne2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne3", $$v)
      },
      expression: "params.firstZtcbDistributionChanne3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne3", $$v)
      },
      expression: "params.secondZtcbDistributionChanne3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne4", $$v)
      },
      expression: "params.firstZtcbDistributionChanne4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne4", $$v)
      },
      expression: "params.secondZtcbDistributionChanne4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n            信息网络出版"), _c('br'), _vm._v("\n            经营情况\n          ")]), _vm._v(" "), _c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbSales", $$v)
      },
      expression: "params.firstWlcbSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbSales", $$v)
      },
      expression: "params.secondWlcbSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbProfit", $$v)
      },
      expression: "params.firstWlcbProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbProfit", $$v)
      },
      expression: "params.secondWlcbProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n            信息网络出版渠道及占比\n            "), _c('br'), _vm._v(" "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("互联网网络营销平台%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne", $$v)
      },
      expression: "params.firstWlcbDistributionChanne"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne", $$v)
      },
      expression: "params.secondWlcbDistributionChanne"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne1", $$v)
      },
      expression: "params.firstWlcbDistributionChanne1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne1", $$v)
      },
      expression: "params.secondWlcbDistributionChanne1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("如果在网络营销平台同时发行载体出版物，对应销售收入及利润总额也应计入网络出版相关细目。")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("国内发行数量(套)")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstIssueQuantityCn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstIssueQuantityCn),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstIssueQuantityCn", $$v)
      },
      expression: "params.firstIssueQuantityCn"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondIssueQuantityCn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondIssueQuantityCn),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondIssueQuantityCn", $$v)
      },
      expression: "params.secondIssueQuantityCn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("国内发行单价(元)")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstUnitPrice",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstUnitPrice),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstUnitPrice", $$v)
      },
      expression: "params.firstUnitPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondUnitPrice",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondUnitPrice),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondUnitPrice", $$v)
      },
      expression: "params.secondUnitPrice"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("海外发行数量(套)")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstIssueQuantityFn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstIssueQuantityFn),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstIssueQuantityFn", $$v)
      },
      expression: "params.firstIssueQuantityFn"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondIssueQuantityFn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondIssueQuantityFn),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondIssueQuantityFn", $$v)
      },
      expression: "params.secondIssueQuantityFn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("收文量")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSwl", $$v)
      },
      expression: "params.firstSwl"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSwl", $$v)
      },
      expression: "params.secondSwl"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("录用量")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstLyl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstLyl),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstLyl", $$v)
      },
      expression: "params.firstLyl"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondLyl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondLyl),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondLyl", $$v)
      },
      expression: "params.secondLyl"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("发文量")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstFwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstFwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstFwl", $$v)
      },
      expression: "params.firstFwl"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondFwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondFwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondFwl", $$v)
      },
      expression: "params.secondFwl"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版经营情况信息")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns",
    staticStyle: {
      "float": "right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c7f0a26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/SuccessivePart/forEdit/ssTab3.vue
// module id = 1751
// module chunks = 1